import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  z-index: 999;

  .menuNavBar {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0.5rem 1rem;
    border-bottom-right-radius: 2rem;

    background: linear-gradient(
      129.19deg,
      ${({ theme }) => theme.colors.primary} -5.89%,
      ${({ theme }) => theme.colors.secondary} 119.74%
    );

    .optionMenuNavBar {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      color: ${({ theme }) => theme.colors.background_white};
      text-decoration: none;
      margin: 0.3rem 0;
      svg {
        min-width: 1.2rem;
        max-width: 1.2rem;
        min-height: 1.2rem;
        max-height: 1.2rem;
        fill: ${({ theme }) => theme.colors.background_white};
      }
      p {
        font-size: 1.3rem;
        font-weight: 300;
        color: ${({ theme }) => theme.colors.background_white};
      }

      &:hover,
      &:focus {
        p {
          color: ${({ theme }) => theme.colors.yellow_200};
        }

        svg {
          fill: ${({ theme }) => theme.colors.yellow_200};
        }
      }
    }
  }
`;
